    <template>
        <div class="main mt15 p34 info">
            <div class="my-title">{{info.productName||''}}</div>
            <Form :label-width="120" class="mt15">
                <FormItem label="批单编号：">
                    <span class="lineFeed">{{ info.endorseNo }}</span>
                </FormItem>
                <FormItem label="产品名称：">
                    {{ info.productName }}
                </FormItem>
                <FormItem label="投保公司：">
                    {{ info.applicantName }}
                </FormItem>
                <FormItem label="保费（元）：">
                    <span class="price">{{info.premium}} 元</span>
                </FormItem>
                <FormItem label="批单状态：">
                    {{ info.endorseStatusDesc }}
                </FormItem>
                <FormItem label="批单创建时间：">
                    {{ info.createTime }}
                </FormItem>
                <FormItem label="保单编号：">
                    {{ info.cntrNo?info.cntrNo:info.guaranteeNo }}
                </FormItem>
                <FormItem label="订单编号：">
                    {{ info.orderNo }}
                </FormItem>
                <FormItem v-if="info.endorseStatus=='FINISHED'" label="批单确认时间：">
                    {{ info.updateTime }}
                </FormItem>
                <FormItem label="批改单：">
                    <div v-for="(item,index) in imgList" :key="index" style="word-wrap:break-word; word-break:break-all;">
                        {{ item }}
                        <a :href="item" target="_blank" rel="opener" class="ml15">查看</a>
                    </div>
                </FormItem>
                <FormItem label="备注：" v-if="info.remark">
                    {{ info.remark }}
                </FormItem>
            </Form>
            <!-- 参加人员信息货车雇主责任险按人 -->
            <RecognizeInfoForTruckPerosn :info="info" from="rider" title="参加人员信息" />
            <!-- 申请人信息通用框架 -->
            <ApplicantInfoForCommon :info="info.applicantInfo" :upload-file-list="applicantUploadFileList"/>
        </div>
    </template>
    <script>
    import PolicyBasicInfoForCommon from '../common/PolicyBasicInfoForCommon'
    import ApplicantInfoForCommon from '../../common/ApplicantInfo'
    import {applicantUploadFileMap} from '@/pages/haierProduct/common/dictionary'
    import RecognizeInfoForTruckPerosn from '../../truckEmployer/person/RecognizeInfo'
    export default {
        components:{ 
            PolicyBasicInfoForCommon,
            ApplicantInfoForCommon,
            RecognizeInfoForTruckPerosn
        },
        data () {
            return {
                info:{},
                id:this.$route.params.id,
                type:this.$route.params.type||'',
                loading:false,
            }
        },
        computed:{
            applicantUploadFileList(){
                if(this.info){
                    let list=applicantUploadFileMap[this.info.productCode]
                    if(list){
                        return list.filter(item=>{
                            return item.identityType==this.info.applicantInfo.identityType
                        })
                    }
                }
                return []
            },
            imgList(){
                return this.info.subjectMatterUrls?this.info.subjectMatterUrls.split(','):[]
            }
        },
        created () {
            this.getPolicyInfo();
        },
        methods:{
            // 获取保单信息
            getPolicyInfo(){
                this.$axios.get('/broker/insurance/endorse/detailByEndorseNo',{
                    endorseNo: this.id
                }).then(res=>{
                    this.info = res;
                    this.info.applicantInfo=this.info.applicantList&&this.info.applicantList.length>0?this.info.applicantList[0]:{}
                });
            }
        }
    }
    </script>
    <style lang="less" scoped>
        .price{
            color:red;
            font-weight: bold;
        }
    </style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/rider/Detail.vue